import ContentLoader from 'react-content-loader';

const ListPlaceholder = (props) => (
  <ContentLoader
    speed={4}
    width={1166}
    height={1220}
    viewBox="0 0 1166 1220"
    backgroundColor="#e7eaee"
    foregroundColor="#f83c3c"
    {...props}
  >
    <rect x="0" y="0" rx="10" ry="10" width="1166" height="200" />
    <rect x="0" y="220" rx="10" ry="10" width="1166" height="200" />
    <rect x="0" y="440" rx="10" ry="10" width="1166" height="200" />
    <rect x="0" y="660" rx="10" ry="10" width="1166" height="200" />
    <rect x="0" y="880" rx="10" ry="10" width="1166" height="200" />
  </ContentLoader>
);

export default ListPlaceholder